import React from "react"
import './card.css'

export const CPCard = ({children,className = "",onClickChange, style = {}}) => {
    return (
        <div style={style}  className={`container_card ${className}` } onClick={onClickChange}>
            {children}
        </div>
    );
}